import React from "react";
import { User, Mail, Shield, Building2, Calendar, CheckCircle } from "lucide-react";
import PageHeader from "../../components/PageHeader";
import { useAuth } from "../../context/Auth/AuthContext";

const Profile = () => {
  const { user } = useAuth();

  const resolveProfileImage = (u) => {
    if (!u?.profileImage) return null;
    const base = process.env.REACT_APP_BACKEND_URL || "";
    return `${base.replace(/\/$/, "")}/public/company${u.companyId}/user/${u.profileImage}`;
  };

  return (
    <div className="space-y-6">
      <PageHeader
        breadcrumb="Conta & Segurança"
        title="Perfil do Administrador"
        subtitle="Informações cadastrais e credenciais da conta"
      />

      <div className="neumorphic-card rounded-3xl p-6 sm:p-8 border border-white/5 space-y-6">
        <div className="flex flex-col sm:flex-row items-center gap-6 pb-6 border-b border-white/5">
          <div className="w-24 h-24 rounded-full overflow-hidden border-2 border-purple-500/40 bg-purple-600/20 flex items-center justify-center text-3xl font-extrabold text-white shadow-purple-glow">
            {resolveProfileImage(user) ? (
              <img src={resolveProfileImage(user)} alt="Avatar" className="w-full h-full object-cover" />
            ) : (
              user?.name?.[0]?.toUpperCase() || user?.email?.[0]?.toUpperCase() || "A"
            )}
          </div>
          <div className="text-center sm:text-left space-y-1">
            <h2 className="text-2xl font-bold text-white tracking-tight">{user?.name || "Administrador"}</h2>
            <p className="text-sm text-gray-400 font-medium">{user?.email}</p>
            <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-purple-500/10 border border-purple-500/20 text-purple-300 text-xs font-bold uppercase tracking-wider mt-1">
              <Shield size={12} /> Superadministrador
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="p-4 rounded-2xl bg-white/5 border border-white/5 space-y-1">
            <span className="text-[11px] font-bold text-gray-400 uppercase tracking-wider flex items-center gap-1.5">
              <User size={13} className="text-purple-400" /> Nome Completo
            </span>
            <div className="text-sm font-semibold text-white">{user?.name || "—"}</div>
          </div>

          <div className="p-4 rounded-2xl bg-white/5 border border-white/5 space-y-1">
            <span className="text-[11px] font-bold text-gray-400 uppercase tracking-wider flex items-center gap-1.5">
              <Mail size={13} className="text-purple-400" /> Endereço de E-mail
            </span>
            <div className="text-sm font-semibold text-white">{user?.email || "—"}</div>
          </div>

          <div className="p-4 rounded-2xl bg-white/5 border border-white/5 space-y-1">
            <span className="text-[11px] font-bold text-gray-400 uppercase tracking-wider flex items-center gap-1.5">
              <Building2 size={13} className="text-purple-400" /> Empresa Principal
            </span>
            <div className="text-sm font-semibold text-white">{user?.company?.name || `#${user?.companyId || "—"}`}</div>
          </div>

          <div className="p-4 rounded-2xl bg-white/5 border border-white/5 space-y-1">
            <span className="text-[11px] font-bold text-gray-400 uppercase tracking-wider flex items-center gap-1.5">
              <CheckCircle size={13} className="text-purple-400" /> Status da Conta
            </span>
            <div className="text-sm font-semibold text-emerald-400 capitalize">{user?.accountStatus || "Ativo"}</div>
          </div>

          <div className="p-4 rounded-2xl bg-white/5 border border-white/5 space-y-1">
            <span className="text-[11px] font-bold text-gray-400 uppercase tracking-wider flex items-center gap-1.5">
              <Calendar size={13} className="text-purple-400" /> Data de Criação
            </span>
            <div className="text-sm font-semibold text-white">
              {user?.createdAt ? new Date(user.createdAt).toLocaleDateString("pt-BR") : "—"}
            </div>
          </div>

          <div className="p-4 rounded-2xl bg-white/5 border border-white/5 space-y-1">
            <span className="text-[11px] font-bold text-gray-400 uppercase tracking-wider flex items-center gap-1.5">
              <Calendar size={13} className="text-purple-400" /> Última Atualização
            </span>
            <div className="text-sm font-semibold text-white">
              {user?.updatedAt ? new Date(user.updatedAt).toLocaleDateString("pt-BR") : "—"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
